module.exports = {
  pool: {
    UserPoolId: process.env.REACT_APP_USER_POOL_ID,
    ClientId: process.env.REACT_APP_CLIENT_ID,
  },
  region: process.env.REACT_APP_REGION,
  IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
};

/*
production credentials
export STAGE=prod
export DYNAMODB_PORT=8000
export USER_POOL_ID=us-east-1_gq9355VWI
export USERPOOL_COGNITO_ARN=arn:aws:cognito-idp:us-east-1:495483525753:userpool/us-east-1_gq9355VWI
export USERPOOL_CLIENT_ID=2cqfk5fm73rilfj1fm1g29fsa7
export AWS_SHARED_CREDENTIALS_FILE=~/.aws/credentials
export AWS_ACCESS_KEY= AKIAJVKELIIJGLGP2Z7A
export AWS_SECRET_KEY=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

Identity Pool id = us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e */


// /*
// export DYNAMODB_PORT=8000
// export USER_POOL_ID=us-east-1_xnqcFszqf
// export USERPOOL_COGNITO_ARN=arn:aws:cognito-idp:us-east-1:
//  269483161851:userpool/us-east-1_xnqcFszqf
// export USERPOOL_CLIENT_ID=3on13ieac509iaegmr1r2oilq9
// export AWS_SHARED_CREDENTIALS_FILE=~/.aws/credentials
//
// Identity Pool id = us-east-1:67ae8f01-a6ab-4c20-90cc-5b93ec056ad3*/



//////////////////
// WEBPACK FOOTER
// ./config/aws.config.js
// module id = 391
// module chunks = 0